import React, {FC} from 'react';

import {InboxesPanelId} from '../../../store/panels/panelStateBase';
import {StartGuideTasksBannerContainer} from '../../app/banners/startGuideTasks/startGuideTasksBannerContainer';
import {ChannelErrorBannersContainer} from './channelError/channelErrorBannersContainer';
import {ChannelImportBannerContainer} from './channelImport/channelImportBannerContainer';
import {CustomViewBackfillBannersContainer} from './customViewBackfill/customViewBackfillBannersContainer';
import {MassArchiveBannersContainer} from './massArchive/massArchiveBannersContainer';
import {PinTagErrorsBannerContainer} from './pinTagErrors/pinTagErrorsBannerContainer';
import {ReactionsBannersContainer} from './reactions/reactionsBannersContainer';
import {RuleCreatedBannerContainer} from './ruleCreated/ruleCreatedBannerContainer';
import {SelectAllBannersContainer} from './selectAll/selectAllBannersContainer';
import {SuppressionListsRemovalBannerContainer} from './suppressionLists/suppressionListsRemovalBannerContainer';

/*
 * Props.
 */

export interface InboxesBannersProps {
  panelId: InboxesPanelId;
}

/*
 * Component.
 */

export const InboxesBanners: FC<InboxesBannersProps> = ({panelId}) => (
  <>
    <ChannelErrorBannersContainer />
    <ChannelImportBannerContainer />
    <SuppressionListsRemovalBannerContainer />

    <ReactionsBannersContainer />
    <RuleCreatedBannerContainer />
    <PinTagErrorsBannerContainer panelId={panelId} />

    <MassArchiveBannersContainer />
    <CustomViewBackfillBannersContainer />
    <SelectAllBannersContainer />

    <StartGuideTasksBannerContainer />
  </>
);
